<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-usercollect__usercollect}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.userId" placeholder="用户ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.type" placeholder="请选择点击类型" clearable>
            <el-option label="收藏记录" :value="1"></el-option>
            <el-option label="点赞记录" :value="2"></el-option>
            <el-option label="视频播放时长记录" :value="3"></el-option>
            <el-option label="浏览记录" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('usercollect:usercollect:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('usercollect:usercollect:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键ID" width="100" header-align="center" align="center" v-show="false"></el-table-column>
        <el-table-column prop="userId" label="用户ID" width="100" header-align="center" align="center"></el-table-column>
        <el-table-column prop="collectName" label="资源标题" width="150" header-align="center" align="center"></el-table-column>

        <el-table-column prop="collectImage" label="资源详情图" header-align="center" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.collectImage" width="100" height="40" alt=""/>
          </template>
        </el-table-column>

        <el-table-column prop="collectHot" label="热度" width="100" header-align="center" align="center"></el-table-column>
        <el-table-column prop="collectDuration" label="播放时长" :show-overflow-tooltip="true" width="100" header-align="center" align="center">
          <template slot-scope="scope">
            {{ formatDuration(scope.row.collectDuration) }}
          </template>
        </el-table-column>

        <el-table-column prop="collectCode" label="资源id" width="100" header-align="center" align="center"></el-table-column>
        <el-table-column prop="collectAuthor" label="资源作者" :show-overflow-tooltip="true" width="100" header-align="center" align="center"></el-table-column>

<!--        <el-table-column prop="collectType" label="资源类型" width="100" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="collectType" label="资源类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.collectType === 1">小说</el-tag>
            <el-tag v-if="scope.row.collectType === 2" size="success" type="success">影视</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sortNum" label="排序号" width="100" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="type" label="类型" :show-overflow-tooltip="true" width="100" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="type" label="点击类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 1" type="warning">收藏记录</el-tag>
            <el-tag v-if="scope.row.type === 2" type="success">点赞记录</el-tag>
            <el-tag v-if="scope.row.type === 3" type="info">视频播放时长记录</el-tag>
            <el-tag v-if="scope.row.type === 4" type="primary">浏览记录</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" label="创建时间" width="180" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('usercollect:usercollect:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('usercollect:usercollect:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './usercollect-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/usercollect/usercollect/page',
        getDataListIsPage: true,
        exportURL: '/usercollect/usercollect/export',
        deleteURL: '/usercollect/usercollect',
        deleteIsBatch: true
      },
      dataForm: {
        userId: '',
        type: null
      }
    }
  },
  components: {
    AddOrUpdate
  },
  methods: {
    formatDuration(duration) {
      // 如果duration为空或null，返回空字符串
      if (duration === null || duration === undefined || duration === '') {
        return ''
      }
      // 将字符串转换为数字并保留2位小数
      const num = parseFloat(duration)
      if (isNaN(num)) {
        return duration // 如果不是数字，返回原值
      }
      return num.toFixed(2)
    }
  }
}
</script>
